<template>
    <div class="heroCont">
        <div class="contentZone">
            <div class="cont" v-if="titolo">
                <div class="breadcrumbHeroCont" v-if="routes">
                    <OggettoBreadcrumbText :routes="routes" />
                </div>
                <h1 class="title1b">{{ titolo }}</h1>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
defineProps<{ titolo?: string; routes?: any }>()
</script>

<style lang="scss" scoped>
.heroCont {
    padding: var(--margin-gap) var(--margin-page);

    .contentZone {
        position: relative;
        z-index: 1;
        padding: calc(var(--margin-header) * 2 - 10px);
        padding-top: var(--size-hero-safetop);

        .breadcrumbHeroCont {
            margin-bottom: var(--margin-default);
        }

        h1 {
            text-wrap: balance;
        }
    }
}

@media screen and (max-width: 1360px) {
    .heroCont {

        .contentZone {
            padding: var(--size-hero-safetop) 0 20px 0;
            max-width: 1200px;
            margin: 0 auto;
        }
    }
}

@media screen and (max-width: 600px) {
    .heroCont {
        padding: 0;

        .contentZone {
            padding: 130px var(--margin-page) var(--margin-double) var(--margin-page);
        }
    }
}
</style>